import { atomWithDefault } from "jotai/utils";
import { useAtomValue, useSetAtom } from "jotai";
import {
    BaseQuestionType,
    BaseQuestionTypeMap,
    getTopicTypeList
} from "../../exercise";
import _ from "underscore";
import { atom } from "jotai";
import { toNumber } from "../../service";

export const typesAtom = atomWithDefault(async () => {
    return await getTopicTypeList();
});

// 所有可用试题类型id
export const typeIdsAtom = atom(get =>
    get(typesAtom).map(item => toNumber(item.id))
);

// 获取所有试题类型列表
export function useTopicTypes() {
    return useAtomValue(typesAtom);
}

// 试题子类型
export function useSubTopicType(topicTypeId: number) {
    const types = useAtomValue(typesAtom);
    if (topicTypeId < BaseQuestionType.Mixed) return [];
    if (topicTypeId === BaseQuestionType.Mixed)
        return _.without(
            Object.keys(BaseQuestionTypeMap).map(item => Number(item)),
            BaseQuestionType.Mixed
        );
    const topic = types.find(item => Number(item.id) === topicTypeId);
    if (!topic) throw new Error("未找到试题类型");
    return topic.basicTypeIds
        .split(",")
        .map(str => Number(str) as BaseQuestionType)
        .sort();
}

// 从服务器更新试题类型
export function useUpdateTypes() {
    const updateTypes = useSetAtom(typesAtom);

    async function update() {
        const types = await getTopicTypeList();
        updateTypes(types);
    }

    return update;
}
